import { Injectable } from '@angular/core';
import { Product } from '../product.decorator';
import { IProductDataV3 } from '@df/catalog/product/product';
import { TCustomOption } from '@df/module-product-configuration/model/simple/custom-options/product-configuration-configurable-product-data.service';
import { App } from '@df/core/app';

@Injectable({ providedIn: 'root' })
export class ProductViewComplexService {
    product?: Product<IProductDataV3>;
    customOptions?: TCustomOption[];

    constructor(private app: App) {
        this.app.meta.subscribe(() => {
            if (this.app.meta.model?.type !== 'product') {
                this.product = undefined;
                this.customOptions = undefined;
            }
        });
    }
}
